import { useEffect } from 'react';
export const useCopyPaste = (onCopy, onPaste, deps = []) => {
    useEffect(() => {
        document.documentElement.addEventListener("copy", onCopy);
        document.documentElement.addEventListener("paste", onPaste);
        return () => {
            document.documentElement.removeEventListener("copy", onCopy);
            document.documentElement.removeEventListener("paste", onPaste);
        };
    }, deps);
};
